import axios from 'axios';
import baseService from '../shared/baseService';

const userService = () => baseService('users');
const getUserByQuery = (name: string, profileId: number, showAllStatus: boolean) => axios.get(`users?name=${name}&profileId=${profileId}&showAllStatus=${showAllStatus}`);

export default {
    userService,
    getUserByQuery
};
